import * as React from 'react';
import cx from 'classnames';

import { Table as TableType } from '@tanstack/table-core/build/lib/types';
import { NewTableColumn, NewTableColumnId, NewTableDefaultDataItem, NewTableLoadMetadata, NewTableLoadMetadataSorting } from '../../new-table.types';
import { Header } from './components/header';
import { Body } from './components/body';

import './table-view.styles.scss';

export type NewTableClasses = Partial<{
  root: string;
}>;

export type TableViewProps = {
  classes?: NewTableClasses;
  columns: Array<NewTableColumn<NewTableDefaultDataItem>>;
  itemUniqProperty: string;
  noDataMessage: React.ReactNode;
  loadTableMetadata?: NewTableLoadMetadata;
  currentColumnResizeOffset?: number;
  model: TableType<NewTableDefaultDataItem>;
  isLoading: boolean;
  onLazyLoad?: () => void;
  onColumnResizeEnd?: () => void;
  onRowContextMenu?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
  isRowSelected?: (item: NewTableDefaultDataItem) => boolean;
  onRowClick?: (params: { item: NewTableDefaultDataItem; e: React.MouseEvent<HTMLTableRowElement> }) => void;
  onSort: (sorting: NewTableLoadMetadataSorting) => Promise<void> | void;
  onCellContextMenu?: (params: { 
    columnId: NewTableColumnId;
    coords: {
      x: number;
      y: number;
    };
  }) => void;
  onHeaderContextMenu?: (params: { 
    coords: {
      x: number;
      y: number;
    };
  }) => void;
};

export const TableView: React.FC<TableViewProps> = (props) => {
  const { model, columns, isLoading, loadTableMetadata, classes, itemUniqProperty, noDataMessage, currentColumnResizeOffset, onLazyLoad, onColumnResizeEnd, onRowContextMenu, isRowSelected, onSort, onCellContextMenu, onHeaderContextMenu, onRowClick } = props;

  const rowModel = model.getRowModel();
  const dataLength = rowModel.rows.length;
  
  return (
    <div className={cx('NewTable', classes?.root)}>
      <table className="NewTable__inner" style={{ width: model.getCenterTotalSize() }}>
        <Header
          columns={columns}
          onColumnResizeEnd={onColumnResizeEnd}
          currentColumnResizeOffset={currentColumnResizeOffset}
          model={model.getHeaderGroups()}
          loadTableMetadata={loadTableMetadata}
          onSort={onSort}
          onHeaderContextMenu={onHeaderContextMenu}
          onCellContextMenu={onCellContextMenu}
        />
        {dataLength > 0 && (
          <Body 
            onRowContextMenu={onRowContextMenu}
            isRowSelected={isRowSelected}
            itemUniqProperty={itemUniqProperty}
            onRowClick={onRowClick}
            model={rowModel}
            onLazyLoad={onLazyLoad}
          />
        )}
      </table>
      {dataLength === 0 && !isLoading && (
        <div className="NewTable__message">
          {noDataMessage}
        </div>
      )}
      {dataLength === 0 && isLoading && (
        <div className="NewTable__message">
          Loading...
        </div>
      )}
    </div>
  );
};